import { motion, useMotionValue } from "framer-motion";

interface SlideTransitionProps {
    children: React.ReactNode;
}

export default function SlideTransition ({ children }: SlideTransitionProps) {
    return (
        <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: -100, opacity: 0 }}
            transition={{ duration: 0.3 }}
        >
            {children}
        </motion.div>
    );
};